import { CacheHandler } from 'reusable/utils/cache'
import { AnnouncementEnum } from '@gap/backend/app-services/announcement/enums/AnnouncementEnums'

const userCache = {
   serviceUser: new CacheHandler<string>({ key: 'GapAppServiceUser', cacheLocation: 'localStorage', useRawKey: true }),
   hideCompletedCheckListSteps: new CacheHandler<boolean>({ key: 'GapAppHideCompletedCheckListSteps', cacheLocation: 'localStorage' }),
   dismissedAnnouncements: new CacheHandler<AnnouncementEnum[]>({ key: 'GapAppDismissedAnnouncements', cacheLocation: 'localStorage' })
}

export default userCache
